import { useDispatch, useSelector } from "react-redux";

import { useHistory, useLocation } from "react-router-dom";
import {
  HiHome,
  HiOutlineHome,
  HiOutlineClipboardList,
  HiOutlineLocationMarker,
  HiOutlineShoppingCart,
  HiOutlineUser,
  HiOutlinePencilAlt,
} from "react-icons/hi";
import { basics } from "../../basics";
import { uiActions } from "../../store/Ui-slice";
import { userOrdersActions } from "../../store/userOrders-slice";

const BottomNavbar = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const LoggedIn = useSelector((state: any) => state.auth.isLoggedIn);
  const numberOfCartItems = useSelector(
    (state: any) => state.cart.totalQuantity,
  );
  const numberOfCartItemsNonZero = numberOfCartItems !== 0 && numberOfCartItems;
  const selectedItemHandler = (text: any) => {
    dispatch(userOrdersActions.pageChanger());
    if (LoggedIn) {
      history.push(text);
    } else {
      dispatch(uiActions.toggleModal());
      history.push("/");
    }
  };
  const isActive = (path: string) => location.pathname === path;
  const loginRegisterHandler = () => {
    dispatch(uiActions.toggleModal());
  };
  const updateProfileHandler = () => {
    dispatch(uiActions.toggleUpdateUserModal());
  };

  return (
    <div className="fixed z-20 bottom-0 left-0 right-0 cursor-pointer bg-white backdrop-blur mx-auto max-w-2xl rounded-t-2xl sm:rounded-2xl sm:mb-3 border border-slate-200 shadow-[0_-8px_24px_rgba(15,23,42,0.08)]">
      <div className="flex justify-around items-center h-16 px-2">
        <div
          onClick={() => selectedItemHandler("/")}
          className={`flex flex-col justify-center items-center gap-0.5 min-w-[68px] transition ${
            isActive("/")
              ? "text-emerald-600"
              : "text-slate-500 hover:text-emerald-600"
          }`}
        >
          {isActive("/") ? (
            <HiHome className="w-7 h-7" />
          ) : (
            <HiOutlineHome className="w-7 h-7" />
          )}
          <div className="text-xs font-medium">{basics.showcase}</div>
        </div>

        <div
          onClick={() => selectedItemHandler("/listOfOrders")}
          className={`flex flex-col justify-center items-center gap-0.5 min-w-[68px] transition ${
            isActive("/listOfOrders")
              ? "text-emerald-600"
              : "text-slate-500 hover:text-emerald-600"
          }`}
        >
          <HiOutlineClipboardList className="w-7 h-7" />
          <div className="text-xs font-medium">{basics.myOrders}</div>
        </div>

        <div
          onClick={() => selectedItemHandler("/cartOfUser")}
          className="flex flex-col justify-center items-center min-w-[68px] relative -mt-8"
        >
          {numberOfCartItemsNonZero !== false && (
            <div className="text-[11px] leading-none text-white min-w-[18px] h-[18px] px-1 absolute right-1 top-0 rounded-full bg-rose-600 flex items-center justify-center shadow-sm z-20">
              {numberOfCartItemsNonZero}
            </div>
          )}
          <div className="relative">
            <div className="relative z-10 w-14 h-14 rounded-full bg-emerald-600 flex items-center justify-center ring-4 ring-white">
              <HiOutlineShoppingCart className="w-7 h-7 text-white" />
            </div>

            {/* <span className="absolute rounded-full bg-white -top-0.5 -right-3 w-20 h-20 pointer-events-none" /> */}
            <span
              className="absolute -top-7 right-12 w-6 h-16 pointer-events-none"
              style={{
                left: "calc(100% + 4px)",
                background:
                  "radial-gradient(circle at top left, transparent 39px, #e2e8f0 39px, #e2e8f0 40px, white 40px)",
              }}
            />
            <span
              className="absolute -top-7 -right-4 w-6 h-16 pointer-events-none"
              style={{
                left: "calc(100% + 4px)",
                background:
                  "radial-gradient(circle at top right, transparent 39px, #e2e8f0 39px, #e2e8f0 40px, white 40px)",
              }}
            />
          </div>
        </div>

        <div
          onClick={() => selectedItemHandler("/addresses")}
          className={`flex flex-col justify-center items-center gap-0.5 min-w-[68px] transition ${
            isActive("/addresses")
              ? "text-emerald-600"
              : "text-slate-500 hover:text-emerald-600"
          }`}
        >
          <HiOutlineLocationMarker className="w-7 h-7" />
          <div className="text-xs font-medium">{basics.myAddress}</div>
        </div>

        {LoggedIn ? (
          <div
            onClick={updateProfileHandler}
            className="flex flex-col justify-center items-center gap-0.5 min-w-[68px] text-slate-500 hover:text-emerald-600 transition"
          >
            <HiOutlinePencilAlt className="w-7 h-7" />
            <div className="text-xs font-medium">{basics.updateUserProfile}</div>
          </div>
        ) : (
          <div
            onClick={loginRegisterHandler}
            className="flex flex-col justify-center items-center gap-0.5 min-w-[68px] text-slate-500 hover:text-emerald-600 transition"
          >
            <HiOutlineUser className="w-7 h-7" />
            <div className="text-xs font-medium">{basics.loginOrRegister}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BottomNavbar;
